import { useSession } from "next-auth/react";
import { isUserManager } from "./access";

function useAuthorization() {
  const { data: session, status } = useSession();

  return {
    session,
    status,
    isLoaded: status !== "loading",
    isUserManager: isUserManager(session?.user.groups),
  };
}

export default useAuthorization;
